
import { defineComponent } from 'vue';
import SidebarLinkComponent from './SidebarLinkComp.vue'
import SidebarProfileComponent from './SidebarProfileComp.vue'
import CategoriesMixins from "@/data/CategoriesMixins";


export default defineComponent({
	name: 'SidebarComponent',
  mixins: [CategoriesMixins],
	components: {
		SidebarLinkComponent,
		SidebarProfileComponent
	}
})
